var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M12.3,32.7l-0.6,4.6h21.6l-0.7-4.6c1-6.7,1-13.6,0-20.3l0.7-4.7H11.7l0.6,4.7C11.4,19.1,11.4,26,12.3,32.7z  M30,34.7v1.6h-1.7v-1.6h-1v1.6h-1.6v-1.6h-1.1v1.6H23v-1.6h-1v1.6h-1.7v-1.6h-1v1.6h-1.6v-1.6h-1.1v1.6H15v-1.6h-1.1v1.6h-1 l0.4-3.1h18.3l0.5,3.1H31v-1.6H30z M31.6,32.2H13.3c-0.9-6.4-0.9-12.9,0-19.3h18.3C32.5,19.3,32.5,25.8,31.6,32.2z M15,10.3V8.8 h1.6v1.5h1.1V8.8h1.6v1.5h1V8.8H22v1.5h1V8.8h1.6v1.5h1.1V8.8h1.6v1.5h1V8.8H30v1.5h1V8.8h1.1l-0.5,3H13.3l-0.4-3h1v1.5H15z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#F9F9F9",
  points: "32.1,36.3 31.6,33.2 13.3,33.2 12.9,36.3 13.9,36.3 13.9,34.7 15,34.7 15,36.3 16.6,36.3  16.6,34.7 17.7,34.7 17.7,36.3 19.3,36.3 19.3,34.7 20.3,34.7 20.3,36.3 22,36.3 22,34.7 23,34.7 23,36.3 24.6,36.3 24.6,34.7  25.7,34.7 25.7,36.3 27.3,36.3 27.3,34.7 28.3,34.7 28.3,36.3 30,36.3 30,34.7 31,34.7 31,36.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#F9F9F9",
  points: "12.9,8.8 13.3,11.8 31.6,11.8 32.1,8.8 31,8.8 31,10.3 30,10.3 30,8.8 28.3,8.8 28.3,10.3  27.3,10.3 27.3,8.8 25.7,8.8 25.7,10.3 24.6,10.3 24.6,8.8 23,8.8 23,10.3 22,10.3 22,8.8 20.3,8.8 20.3,10.3 19.3,10.3 19.3,8.8  17.7,8.8 17.7,10.3 16.6,10.3 16.6,8.8 15,8.8 15,10.3 13.9,10.3 13.9,8.8  "
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M13.3,12.9c-0.9,6.4-0.9,12.9,0,19.3h18.3c0.9-6.4,0.9-12.9,0-19.3H13.3z M16.8,24.5c-4-3,2.3-7.3,5-4 c0.7-1,2-2.7,4-2.7c4.4,0,5.1,6,0.5,8.4c-1.2,0.7-2.5,1-3.9,1C20.2,27.2,18.2,26.2,16.8,24.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M25.8,17.8c-2,0-3.3,1.7-4,2.7c-2.7-3.3-9,1-5,4c1.4,1.7,3.4,2.7,5.6,2.7c1.4,0,2.7-0.3,3.9-1 C30.9,23.8,30.2,17.8,25.8,17.8z M17.3,23.6c-0.5-0.4-0.8-0.8-0.7-1.2c0.1-0.6,0.5-1.2,1-1.5c1.8-1,3-0.5,3.6,0.6 C20.2,22.7,18.8,23.4,17.3,23.6z M18.3,24.5c1.6-0.4,3.1-1.4,4-2.8c0.8-1.7,2.5-3.4,4.4-2.7c1.4,0.5,2.1,2,1.6,3.4 C27.4,25.5,22.2,27.9,18.3,24.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M28.3,22.4c0.5-1.4-0.2-2.9-1.6-3.4c-1.9-0.7-3.6,1-4.4,2.7c-0.9,1.4-2.4,2.4-4,2.8 C22.2,27.9,27.4,25.5,28.3,22.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M17.6,20.9c-0.5,0.3-0.9,0.9-1,1.5c-0.1,0.4,0.2,0.8,0.7,1.2c1.5-0.2,2.9-0.9,3.9-2.1 C20.6,20.4,19.4,19.9,17.6,20.9z"
}));

function SvgSnacks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnacks);
export default __webpack_public_path__ + "static/media/snacks.286122cb8690bb43fbbb301576ab5e88.svg";
export { ForwardRef as ReactComponent };